import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import Partners from '../network/partners/partners';
import Network from '../network/network';
import { demoUser } from '@/providers/apis/demo-user/demo-user';
import CollaboratorsPullup from '@/components/collaborators-pullup/collaborators-pullup';

@Component({
    name: 'collaborators',
    components: {
        'material-icons': GoogleMaterialIcon,
        'partners': Partners,
        'collaborators-pullup': CollaboratorsPullup,
    },
})

export default class Collaborators extends Vue {

    // -----------------------------------------------------------------
    // Properties

    private network: Network = new Network();

    private get isTenant() {
        return this.network.isTenant;
    }

    private mapData: any = null;

    // -----------------------------------------------------------------
    // Hooks

    private mounted() {
        const worldMapDataSet = this.network.fetchNavWorldWideMapData();
        worldMapDataSet.then((data) => {
            this.mapData = data;
        });
    }

    // -----------------------------------------------------------------
    // Actions

    private onShowReport() {
        this.$bvModal.show('collaborators-joinee');
    }

}
